export interface IAddCasePageLoadLog_Request {
    FileNumber: string;
    DefedantNumber: string;
}
export interface TypeaheadOption {
    label: string;
    value: string | number;
}

export interface SystemValuesResponse {
    FingerPrintNumberLabel: string;
    ShowFingerprintNumber: boolean;
    ShowNeighborhood: boolean;
    MaintainCaseCategory: boolean;
    CaseCategoryLabel: string;
    ShowBookingPD: boolean;
    Show24HourHold: boolean;
    ShowReportRcvdDate: boolean;
    ShowReferredDate: boolean;
    ReferralDateLabel: string;
    ShowArrestNumber: boolean;
    ArrestNumberLabel: string;
    HourlyHoldAmountJuvenile: string;
    HourlyHoldAmount: string;
    ShowChildIDinAdult: boolean;
    ChildIDLabel: string;
    ShowPrimaryPhoneNumber: boolean;
    ShowAgeWithDecimal: boolean;
    ShowPrefix: boolean;
    ShowStateOfBirth: boolean;
    ShowLocalID: boolean;
    LIDLabel: string;
    StateIDLabel: string;
    ShowStateID: boolean;
    ShowInmateId: boolean;
    InmateIDLabel: string;
    ShowFederalId: boolean;
    FederalIDLabel: string;
    ShowNationality: boolean;
    NationalityLabel: string;
    ShowDefendantStatus: boolean;
    ShowDLClassExp: boolean;
    ShowIntlAddress: boolean;
    ShowNationalityOrEmail: string;
    ChargeEnhancementMethod: string;
    ShowJuvenileCheckbox: boolean;
    RequireWitnessType: boolean;
    ShowChargeEnhancement: boolean;
    ExViewShowReferralButton: boolean;
    lblCourtLabel: string;
    SystemVersion: string;
    ExternalViewNoteType: string;
    DefendantLabel: string;
    ValidateChargeModifier: string;
    ExternalViewDocCategory : string;
    ExViewShowOcn : boolean;
    ExViewShowLID : boolean;
    ExViewShowStateID : boolean;
    ShowTicketNumOnChargeGrid : boolean;
    ShowPoliceBadgeNumber : boolean;
    PoliceBadgeNumberLabel : string;
    ChargeDescriptionSearchField : string;
    ShowSummonDateAndNo: boolean;
}

export interface SystemValues {
    fingerPrintNumberLabel: string | null;
    showFingerprintNumber: boolean;
    showNeighborhood: boolean;
    maintainCaseCategory: boolean;
    caseCategoryLabel: string | null;
    showBookingPD: boolean;
    show24HourHold: boolean;
    showReportRcvdDate: boolean;
    showReferredDate: boolean;
    referralDateLabel: string | null;
    showArrestNumber: boolean;
    arrestNumberLabel: string | null;
    hourlyHoldAmountJuvenile: string;
    hourlyHoldAmount: string;
    showChildIdInAdult: boolean;
    childIdLabel: string | null;
    showPrimaryPhoneNumber: boolean;
    showAgeWithDecimal: boolean;
    showPrefix: boolean;
    showStateOfBirth: boolean;
    showLocalId: boolean;
    lIdLabel: string | null;
    stateIdLabel: string | null;
    showStateId: boolean;
    showInmateId: boolean;
    inmateIdLabel: string | null;
    showFederalId: boolean;
    federalIdLabel: string | null;
    showNationality: boolean;
    nationalityLabel: string | null;
    showDefendantStatus: boolean;
    showDLClassExp: boolean;
    showIntlAddress: boolean;
    showNationalityOrEmail: string | null;
    showJuvenileCheckbox: boolean;
    requireWitnessType: boolean | null;
    chargeEnhancementMethod: string;
    showChargeEnhancement: boolean;
    exViewShowReferralButton: boolean;
    lblCourtLabel: string | null;
    systemVersion: string | null;
    externalViewNoteType: string | null;
    defendantLabel: string | null;
    validateChargeModifier: string | null;
    externalViewDocCategory : string | null;
    exViewShowOcn : boolean;
    exViewShowLID : boolean;
    exViewShowStateID : boolean;
    showTicketNumOnChargeGrid : boolean;
    showPoliceBadgeNumber : boolean;
    policeBadgeNumberLabel : string
    chargeDescriptionSearchField : string;
    showSummonDateAndNo: boolean;
}

export const Default_SessionValue: SystemValues = {
    fingerPrintNumberLabel: null,
    showFingerprintNumber: false,
    showNeighborhood: false,
    maintainCaseCategory: false,
    caseCategoryLabel: null,
    showBookingPD: false,
    show24HourHold: false,
    showReportRcvdDate: false,
    showReferredDate: false,
    referralDateLabel: null,
    showArrestNumber: false,
    arrestNumberLabel: null,
    hourlyHoldAmountJuvenile: '',
    hourlyHoldAmount: '',
    showChildIdInAdult: false,
    childIdLabel: null,
    showPrimaryPhoneNumber: false,
    showAgeWithDecimal: false,
    showPrefix: false,
    showStateOfBirth: false,
    showLocalId: false,
    lIdLabel: null,
    stateIdLabel: null,
    showStateId: false,
    showInmateId: false,
    inmateIdLabel: null,
    showFederalId: false,
    federalIdLabel: null,
    showNationality: false,
    nationalityLabel: null,
    showDefendantStatus: false,
    showDLClassExp: false,
    showIntlAddress: false,
    showNationalityOrEmail: null,
    showJuvenileCheckbox: false,
    requireWitnessType: null,
    chargeEnhancementMethod: '',
    showChargeEnhancement: false,
    exViewShowReferralButton: false,
    lblCourtLabel: null,
    systemVersion: null,
    externalViewNoteType: null,
    defendantLabel: null,
    validateChargeModifier: null,
    externalViewDocCategory : null,
    exViewShowOcn : false,
    exViewShowLID: false,
    exViewShowStateID: false,
    showTicketNumOnChargeGrid: false,
    showPoliceBadgeNumber : false,
    policeBadgeNumberLabel : '',
    chargeDescriptionSearchField: '',
    showSummonDateAndNo: false
}

export interface LinkModel {
    title: string;
    link: string;
}

export interface CoDefendantForAttachment {
    fileNumber: string;
    name: string;
    isCurrent: boolean;
    courtNumber: string;
    stage: string;
    status: string;
    defendantNumber: string;
  }